<template>
  <handle-password-reset v-if="mode === 'resetPassword'" :code="code"/>
  <handle-verify-email v-else-if="mode === 'verifyEmail' || 'handleVerifyEmail'" :code="code"
                       :success-token="successToken"/>
</template>

<script>
import HandlePasswordReset from "./HandleResetPassword";
import HandleVerifyEmail from "./HandleVerifyEmail";

export default {
  name: "HandleAuthAction",
  components: {HandleVerifyEmail, HandlePasswordReset},
  props: ["mode", "code", "successToken"]
}
</script>

<style scoped>

</style>